import loadResponsiveImages from './responsiveImages'
import loadMobileMenu from './mobileMenu'
import loadLocationsMap from './locationsMap'
import loadTabs from './tabs'
import loadImageGalleries from './imageGalleries'
import loadFloorPlans from './floorPlans'
import loadScrollDown from './scrollDown'
import loadLocationNav from './locationNav'
import loadLocationTour from './locationTour'
import loadLocationMenuScroll from './locationMenuScroll'
import loadVideoModals from './videoModals'
// import loadLocationsFinder from './locationsFinder'
import loadGoogleReviews from './googleReviews'

if (document.documentMode) {
    document.documentElement.classList.add(`ie${document.documentMode}`)
}

document.addEventListener('DOMContentLoaded', () => {
    loadResponsiveImages()
    loadMobileMenu()
    loadLocationsMap()
    loadTabs()
    loadImageGalleries()
    loadFloorPlans()
    loadScrollDown()
    loadLocationNav()
    loadLocationTour()
    loadLocationMenuScroll()
    loadVideoModals()
    // loadLocationsFinder()
    loadGoogleReviews()
})



// WEBPACK FOOTER //
// ./js/main.js